import _ from 'lodash'
import userService from '../../../services/userService'
import localStorage from 'localStorage'

const initialState = {
    connected: false,
    user: {}
}

const state = initialState

// getters
const getters = {
    isConnected: state => state.connected,
    isAdmin: state => {
        return !_.isUndefined(state.user.todReporting) &&
            !_.isUndefined(state.user.todReporting.isAdmin) &&
            state.user.todReporting.isAdmin
    },
    pam: state => {
        return !_.isUndefined(state.user.todReporting) &&
            !_.isUndefined(state.user.todReporting.pam) &&
            state.user.todReporting.pam
    },
    getUser: state => state.user,
    getFullName(state) {
        return state.user.label
    },
    getTodReportingInformations(state) {
        return state.user.todReporting || []
    }
}

// actions
const actions = {
    setConnected: (store, status) => {
        // eslint-disable-next-line
        return new Promise((resolve, reject) => {
            store.commit('SET_CONNECTED', status)
            resolve(1)
        })

    },
    setUser: (store, user) => {
        // eslint-disable-next-line
        return new Promise((resolve, reject) => {
            store.commit('SET_USER', user)
            resolve(1)
        })
    },
    setToken: (store, token) => {
        // eslint-disable-next-line
        return new Promise((resolve, reject) => {
            store.commit('SET_TOKEN', token)
            resolve(1)
        })
    },
    async setSitesAuthorized(store, allSites) {
        store.commit('SET_ALL_SITES_AUTHORIZED', _.clone(allSites))
        setTimeout(() => {
            return userService.updateUser()
        }, 500)
    },
    resetStore(store) {
        // eslint-disable-next-line
        console.log("resetStore")
        store.commit('RESET_ALL_STORE')
    },

}

// mutations
const mutations = {
    SET_CONNECTED: (state, status) => {
        state.connected = status
    },
    SET_USER: (state, user) => {
        state.user = user
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    RESET_ALL_STORE: (state) => {
        Object.assign(state, _.cloneDeep(initialState))
        localStorage.clear()
    },
    /*SET_ALL_SITES_AUTHORIZED: (state, allSites) => {
        state.user['todReporting']['sitesAuthorize'] = allSites
    }*/
}

export default {
    state,
    getters,
    actions,
    mutations
}
